const pageList = {
    latitude: null,
    longitude: null
};
window.pageList = pageList;

// フォーム要素の定義
$(document).ready(function (e) {
    if ($(".js-list-page").length === 0) {
        return;
    }

    // GPSがONになったら距離計算開始。
    distance.callback = function () {
        // 距離計算が必要なときは起動
        $(".js-distance").map(function () {
            if (pageList.latitude && pageList.longitude) {
                const latitudeTo = $(this).data("latitude").toFixed(3);
                const longitudeTo = $(this).data("longitude").toFixed(3);

                $(this).html(distance.getDistance(latitudeTo, longitudeTo));
                $(this).slideDown();
            }
        });
    };

    // 距離情報の有効／無効判定
    distanceEnableFlg = searchCondition.distanceEnable();

    // 自宅位置を取得する。全く同じ位置の場合は自宅と判断する。
    if ($(".js-parentUserInfo").length) {
        $(".js-parentUserInfo").data("latitude");
        $(".js-parentUserInfo").data("longitude");

        if (
            $(".js-currentCenterLatitudeLongitude").data("latitude") === $(".js-parentUserInfo").data("latitude") &&
            $(".js-currentCenterLatitudeLongitude").data("longitude") === $(".js-parentUserInfo").data("longitude")
        ) {
            distance.setHome();
        }
    }

    pageList.latitude = $(".js-currentCenterLatitudeLongitude").data("latitude");
    pageList.longitude = $(".js-currentCenterLatitudeLongitude").data("longitude");

    modalWindow.enableButton();

    // お気に入りをおした
    $(".js-favorite-button").click(function (e) {
        // NOTE: この付近の施設のリンク内にあるボタンのためページ遷移するイベントをリセットしている
        if (e.target.classList.contains("js-prevent-default")) {
            e.preventDefault();
        }
        // NOTE: メモを持っているときは確認画面を出す
        if ($(this).data("has-review")) {
            document.querySelector(".js-confirm").dataset.nursery_id = $(this).data("nursery_id");
            modalWindow.showModal($(this).data("target"));
            return;
        }
        favorite.toggle($(this).data("nursery_id"));
    });

    // 削除はいボタンを押したとき
    $(".js-confirm").unbind();
    $(".js-confirm").on("click", function () {
        favorite.toggle($(this).data("nursery_id"));
        $(".js-modal-hide").trigger("click");
    });

    // 自宅を押した
    $(".button-small--home").click(function () {
        // ログイン情報エリアが存在するか確認。存在しなければログイン画面を表示する。
        if ($(".js-parentUserInfo").length === 0) {
            modalWindow.showModal("#js-modal-regist-guide");
        } else {
            distance.setHome();
            pageList.latitude = distance.referenceLatitude;
            pageList.longitude = distance.referenceLongitude;

            $("#search").val("");

            $(".js-search").trigger("click");
        }
    });
    // 現在位置を押した
    $(".button-small--current-location").click(function () {
        distance.setGps();
        pageList.latitude = distance.referenceLatitude;
        pageList.longitude = distance.referenceLongitude;

        $("#search").val("");

        $(".js-search").trigger("click");
    });

    // 「認可」チェックボックスの処理
    eventHandler.handleCheckboxChangeInteractions(".js-licensed-nursery-parent", ".js-licensed-nursery-child");
    // 「認可外」チェックボックスの処理
    eventHandler.handleCheckboxChangeInteractions(".js-unlicensed-nursery-parent", ".js-unlicensed-nursery-child");

    // 検索ボタンを押した
    $(".js-search-condition, .js-search").click(function () {
        let gpsOnFlg = "";
        if (distance.distanceMode === "current") {
            gpsOnFlg = true;
        }

        const paramString = searchCondition.getSearchParamListWithKeyword(
            pageList.latitude,
            pageList.longitude,
            gpsOnFlg
        );
        window.location.href = "/search/" + paramString;
    });

    // エンターキーの初期化
    $("#search").keypress(function (e) {
        if (e.keyCode === 13) {
            $(".js-search").trigger("click");
            return false;
        }
    });

    // 検索クリアボタンを押した
    $(".js-clear").click(function () {
        // 条件を全消し
        $("#js-modal-condition").find("[type=checkbox]").prop("checked", false);

        // ラジオを所定位置
        $("#js-modal-condition").find("[name=distance]:last").prop("checked", true);

        // 登園/お迎え時間 を「指定なし」に戻す
        $("#js-modal-condition").find("select[name=startTime]").val("");
        $("#js-modal-condition").find("select[name=endTime]").val("");
    });
});
